/* candy-product.js — BAND 1 of the product page: gallery, buy column, sticky ATC bar.
   ==========================================================================
   SPLIT 2026-09. This file used to be the whole product page in one IIFE, anchored by
   document.currentScript.closest('.custom-prd7k9'). The page is now six sibling sections,
   so the parts that were genuinely page-wide rather than band-wide — money(), the one
   lightbox, the carousel hand-off, the rec-card Add delegation and the recently-viewed
   list — moved to assets/candy-product-core.js. What is left here is band 1 and nothing
   else.

   The anchor is CandyPrd.ready() rather than currentScript: it runs once per matching
   root, again after a theme-editor re-render, and never twice for the same root. */
(function(){
  if(!window.CandyPrd) return;
  var CP = window.CandyPrd;
  CP.ready('.custom-prd7k9[data-prd-part="main"]', function(root){
      CP.useMoneyFormat(root.getAttribute('data-money-format'));
      var money = CP.money;
      var variants = [];
      try{ variants = JSON.parse(root.querySelector('[data-prd-variants]').textContent); }catch(e){}
      /* the basket drawer shows a variant's own photo instead of the drawn pack, and /cart.js cannot
         tell it which variants have one; this page can, so it says so (see the drawer's render()) */
      try{
        window.C4U_OWN = window.C4U_OWN || {};
        (variants || []).forEach(function(v){ window.C4U_OWN[v.id] = !!v.own; });
      }catch(e){}
      var LOW = parseInt(root.getAttribute('data-low'), 10) || 8;
      /* parse "250g" / "1kg" style titles into grams for the savings maths */
      function grams(title){
        var m = /([\d.]+)\s*(kg|g)/i.exec(title || '');
        if(!m) return 0;
        return parseFloat(m[1]) * (m[2].toLowerCase() === 'kg' ? 1000 : 1);
      }

      var cur = variants[0] || null;

      var currentId = parseInt(root.getAttribute('data-current-id'), 10);
      for(var i = 0; i < variants.length; i++){ if(variants[i].id === currentId) cur = variants[i]; }
      var qty = 1;   /* the one-time / subscribe choice went with the widget (client 2026-08-22) */

      var priceEl = root.querySelector('[data-price]');
      var compEl  = root.querySelector('[data-compare]');
      var offEl   = root.querySelector('[data-off]');
      var saveEl  = root.querySelector('[data-saving]');
      var fastEl  = root.querySelector('[data-fast]');
      var fastQtyEl = root.querySelector('[data-fast-qty]');
      var qtyEl   = root.querySelector('[data-qty]');
      var purchaseQty = root.querySelector('[data-purchase-qty]');
      var buyRow = root.querySelector('[data-buyrow]');
      var notifyWish = root.querySelector('[data-notify-wish]');
      var atcBtn  = root.querySelector('[data-atc]');
      var atcT    = root.querySelector('[data-atc-t]');
      var barEl   = root.querySelector('[data-bar]');
      var barPrice = root.querySelector('[data-bar-price]');
      /* PRICE PER 100G (client 2026-09-14: "it should update when a size is selected"). A size with a
         weight shows its own figure. Without one, the sheet's figure (data-ppg) stands only beside the
         cheapest size, the one the "From" price names; any other size shows no line rather than a
         number that is not true for it. "From" goes on the first pick. */
      var fromEl = root.querySelector('[data-from]');
      var ppgEl = root.querySelector('[data-ppg-line]');
      var sheetPpg = parseInt(root.getAttribute('data-ppg'), 10) || 0;
      var minPrice = parseInt(root.getAttribute('data-min'), 10) || 0;
      var picked = false;
      /* ---- SUBSCRIBE & SAVE (user 2026-10-06, mockup 05 "One-line toggle"; markup and note in
         candy-product.liquid). The row is only printed for a product with a selling plan. Each size
         carries Shopify's own subscription price per plan (v.sp), so a size the plan does not cover
         hides the row and sells one-time. On, the chosen plan's price shows everywhere the price does
         and the plan goes to the basket with the line. ---- */
      var subEl = root.querySelector('[data-sub]');
      var subOn = !!(subEl && subEl.hasAttribute('data-sub-required'));
      var subChips = subEl ? Array.prototype.slice.call(subEl.querySelectorAll('[data-sp]')) : [];
      var subPct = subEl ? (parseInt(subEl.getAttribute('data-sub-pct'), 10) || 0) : 0;
      var subPlan = 0;
      if(subChips.length){
        /* opens on the 4-week plan when there is one, as in the mockup, else the first */
        var subFour = subChips.filter(function(c){ return /\b4\s*weeks?\b/i.test(c.getAttribute('data-sp-opt') || c.textContent); })[0];
        subPlan = parseInt((subFour || subChips[0]).getAttribute('data-sp'), 10);
      }
      function subAlloc(v){
        if(!v || !v.sp || !subPlan) return null;
        for(var k = 0; k < v.sp.length; k++){ if(v.sp[k].id === subPlan) return v.sp[k]; }
        return null;
      }
      function subLive(){ return subOn && subAlloc(cur) ? subAlloc(cur) : null; }
      function atcLabel(){
        if(cur && !cur.available) return 'Sold out';
        return subLive() ? 'Subscribe' + (subPct ? ' & save ' + subPct + '%' : '') : 'Add to basket';
      }
      function subDays(txt){
        var m = /(\d+)\s*(day|week|month)/i.exec(txt || '');
        if(!m) return 0;
        var n = parseInt(m[1], 10), u = m[2].toLowerCase();
        return u === 'day' ? n : (u === 'week' ? n * 7 : n * 30);
      }
      function paintSub(){
        if(!subEl) return;
        var a = subAlloc(cur);
        subEl.hidden = !a;
        if(!a) return;
        subEl.classList.toggle('custom-prd7k9__sub--on', subOn);
        var tg = subEl.querySelector('[data-sub-toggle]');
        if(tg) tg.setAttribute('aria-pressed', subOn ? 'true' : 'false');
        var pe = subEl.querySelector('[data-sub-price]'), we = subEl.querySelector('[data-sub-was]');
        if(pe) pe.textContent = money(a.price);
        if(we) we.textContent = money(cur.price);
        var onChip = null;
        subChips.forEach(function(c){
          var on = parseInt(c.getAttribute('data-sp'), 10) === subPlan;
          if(on) onChip = c;
          c.classList.toggle('custom-prd7k9__sub-chip--on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var days = onChip ? subDays(onChip.getAttribute('data-sp-opt') || onChip.textContent) : 0;
        var nr = subEl.querySelector('[data-sub-next-row]'), ne = subEl.querySelector('[data-sub-next]');
        if(nr) nr.hidden = !days;
        if(ne && days){
          var d = new Date(); d.setDate(d.getDate() + days);
          ne.textContent = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
        }
      }
      if(subEl) subEl.addEventListener('click', function(e){
        var chip = e.target.closest('[data-sp]');
        if(chip){ subPlan = parseInt(chip.getAttribute('data-sp'), 10); subOn = true; paint(); return; }
        if(e.target.closest('[data-sub-toggle]') && !subEl.hasAttribute('data-sub-required')){ subOn = !subOn; paint(); }
      });
      function ppgFor(v){
        if(v.grams > 0) return Math.round(v.price / v.grams * 100);
        if(sheetPpg > 0 && v.price === minPrice) return sheetPpg;
        return 0;
      }

      /* ---- buy more save more: per-gram vs the smallest size ---- */
      var base = null;
      variants.forEach(function(v){
        var g = grams(v.title);
        if(g > 0 && (!base || g < base.g)) base = { g: g, price: v.price };
      });
      function savePct(v){
        var g = grams(v.title);
        if(!base || !g || g <= base.g) return 0;
        var per = v.price / g, basePer = base.price / base.g;
        return Math.max(0, Math.round((1 - per / basePer) * 100));
      }
      (function bmsm(){
        var rowsEl = root.querySelector('[data-bmsm-rows]');
        var box = root.querySelector('[data-bmsm]');
        if(!rowsEl || !box || !base) return;
        var rows = '';
        variants.forEach(function(v){
          var s = savePct(v);
          rows += '<div class="custom-prd7k9__bmsm-row"><span>' + v.title + ' — ' + money(v.price) + '</span>' +
                  (s > 0 ? '<b>Save ' + s + '%</b>' : '<span>&mdash;</span>') + '</div>';
        });
        var any = variants.some(function(v){ return savePct(v) > 0; });
        if(any){ rowsEl.innerHTML = rows; box.hidden = false; }
      })();
      /* per-size save chips on the pills */
      root.querySelectorAll('.custom-prd7k9__size').forEach(function(btn){
        var v = variants.filter(function(x){ return String(x.id) === btn.getAttribute('data-vid'); })[0];
        if(!v) return;
        var s = savePct(v);
        var chip = btn.querySelector('[data-size-save]');
        if(chip && s > 0){ chip.textContent = 'Save ' + s + '%'; chip.hidden = false; }
      });

      /* FILL UP ON THE PACKAGING PILLS (user 2026-09-20: "right packaging have no animations"). A
         pill that shows a real photo of its packaging fills the same way the quick buy rows do, as a
         ripple along the row, once, when the row is actually on screen. */
      (function pillFill(){
        var tiles = root.querySelectorAll('.custom-prd7k9__size-f--photo');
        if(!tiles.length) return;
        /* from here the pill pictures are held until their fill starts (see the hold rule in
           candy-pack.css); set first, synchronously, so there is no frame of a finished pack */
        root.setAttribute('data-fill-ready', '');
        function run(){
          Array.prototype.forEach.call(tiles, function(t, i){
            t.style.setProperty('--i', i);
            if(window.c4uFill) window.c4uFill(t); else t.classList.add('c4u-fill--go');
          });
        }
        var rowEl = tiles[0].closest('.custom-prd7k9__sizes') || tiles[0];
        if(!('IntersectionObserver' in window)){ run(); return; }
        var io = new IntersectionObserver(function(es){
          if(!es[0].isIntersecting) return;
          io.disconnect(); run();
        }, { threshold: 0.35 });
        io.observe(rowEl);
      })();

      /* declared here, not next to its use inside paint(): `var` hoists but its ASSIGNMENT does
         not, and paint() runs on load — read before this line executed it would be undefined,
         which is falsy, and the guard below would let the very jump it exists to prevent through */
      var firstPaint = true;
      var wvEl = root.querySelector('[data-wv]');
      function isContainer(t){ t = String(t || ''); return (/\b(bucket|cups?|tubs?|box|capsule|vault|tins?|jars?|sleeves?)\b/i.test(t) || /^large freeze dried$/i.test(t)) && !/pouch/i.test(t); }
      function paint(){
        if(!cur) return;
        if(wvEl) wvEl.hidden = !isContainer(cur.title);   /* weight & volume note: containers only (client 2026-09-25) */
        var sa = subLive();
        var showPrice = sa ? sa.price : cur.price;
        if(priceEl) priceEl.textContent = money(showPrice);
        if(barPrice) barPrice.textContent = money(showPrice);
        if(fromEl) fromEl.hidden = picked || cur.price !== minPrice;
        if(ppgEl){
          var pc = ppgFor(cur);
          if(pc && sa) pc = Math.round(pc * sa.price / cur.price);
          ppgEl.hidden = !pc;
          if(pc) ppgEl.textContent = money(pc) + ' per 100g';
        }
        if(compEl){
          /* subscribed, the struck price is what buying once would cost (or the compare-at, if higher) */
          var strike = sa ? Math.max(cur.price, cur.compare || 0) : (cur.compare > cur.price ? cur.compare : 0);
          compEl.hidden = !strike;
          if(strike) compEl.textContent = money(strike);
        }
        paintSub();
        /* % off the compare-at price. Deliberately measured against cur.price, the
           ONE-TIME price, not the discounted figure shown in subscribe mode — otherwise
           picking Subscribe would inflate this to the markdown plus the subscription
           saving and claim a discount the customer is not getting off the RRP. */
        if(offEl){
          var offPct = cur.compare > cur.price ? Math.floor((cur.compare - cur.price) / cur.compare * 100) : 0;
          offEl.hidden = offPct <= 0;
          if(offPct > 0) offEl.textContent = offPct + '% OFF';
        }
        /* "Save N% per gram" RETIRED 2026-09-11 (client: "I don't really know what that is").
           The span in candy-product.liquid is commented out, so saveEl is null and this block would
           no-op anyway; kept commented out next to it so the two switch back together.
        if(saveEl){
          var s = savePct(cur);
          saveEl.hidden = !(s > 0);
          if(s > 0) saveEl.textContent = 'Save ' + s + '% per gram';
        }
        */
        if(fastEl){
          var fast = cur.managed && cur.qty > 0 && cur.qty <= LOW;
          fastEl.hidden = !fast;
          if(fast && fastQtyEl) fastQtyEl.textContent = cur.qty;
        }
        if(notifyEl) notifyEl.hidden = cur.available;
        if(purchaseQty) purchaseQty.hidden = !cur.available;
        if(atcBtn) atcBtn.hidden = !cur.available;
        if(buyRow) buyRow.hidden = !cur.available && !!notifyEl;
        /* Move the same heart so its saved state and click handler survive variant changes. */
        var wishHome = !cur.available && notifyWish ? notifyWish : buyRow;
        if(wish && wishHome && wish.parentNode !== wishHome) wishHome.appendChild(wish);
        if(barEl){
          barEl.hidden = !cur.available;
          if(!cur.available){
            barEl.classList.remove('custom-prd7k9__bar--show');
            barEl.setAttribute('aria-hidden', 'true');
          }
        }
        syncAddControls();
        root.querySelectorAll('.custom-prd7k9__size').forEach(function(btn){
          btn.classList.toggle('custom-prd7k9__size--on', btn.getAttribute('data-vid') === String(cur.id));
        });
        try{
          var u = new URL(window.location.href);
          u.searchParams.set('variant', cur.id);
          window.history.replaceState({}, '', u);
        }catch(e){}
        /* Jump the gallery to the variant's media — but ONLY when the shopper actually picks a
           packaging (client 2026-08-22: "when i refresh its auto select 2nd thumbnail").
           On load, `cur` is whatever variant the URL names, and the first paint() ran this too:
           ?variant=…756823 is Teaser Pouch, whose featured media is position 2, so a plain
           refresh landed on the second thumbnail with the page looking like something had been
           clicked. The gallery should open on the product's own first image and only follow a
           deliberate change. */
        /* mediapos is now the variant's place among the PARKED pack shots (1-based), so the slide
           it means is packBase + that. 0 still means "this variant has no photo of its own", and
           then the gallery is left where the shopper had it. */
        if(!firstPaint){
          if(cur.mediapos > 0){
            showSlide(packBase + cur.mediapos);
          } else if(cur.gpos > 0){
            /* SAFETY-VALVE PRODUCTS (Arsalan 2026-09-28, jelly-belly-grape: "variant changing the imgs not
               updating gallery"). When EVERY photo is a pack shot nothing is parked, the pack shots are the
               gallery itself, so mediapos was 0 for all of them and no packaging click moved it. gpos is
               the shot's own place in that gallery. */
            showSlide(cur.gpos);
          } else if(slideI >= packBase || (packBase === slides.length && slideI > 0 && !cur.own)){
            /* this packaging has no shot of its own yet, and the gallery is still showing the LAST
               packaging's — which would read as a Mega Pouch looking exactly like a bucket. Fall
               back to the product's own first picture. */
            showSlide(1);
          }
        }
        firstPaint = false;
      }

      root.querySelectorAll('.custom-prd7k9__size').forEach(function(btn){
        btn.addEventListener('click', function(){
          var v = variants.filter(function(x){ return String(x.id) === btn.getAttribute('data-vid'); })[0];
          if(!v) return;
          /* PHONE: GO TO THE PICTURE FIRST, THEN SWITCH (Arsalan 2026-09-24: "before switching to another variant
             it should goto top and then switch"). The packaging row sits well below the gallery on a phone, so the
             swap happened off screen. If the gallery is not fully in view, glide up to it (clear of the header,
             which comes back on an upward scroll) and only then paint, so the change is seen. */
          var gal = root.querySelector('.custom-prd7k9__gallery');
          var phone = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
          var hdrOff = (function(v){return (parseFloat(v)||0) * (/vw\s*$/.test(v) ? window.innerWidth / 100 : 1);})(getComputedStyle(document.documentElement).getPropertyValue('--c4u-hdr-off'));
          var gr = gal ? gal.getBoundingClientRect() : null;
          if(phone && gr && (gr.top < hdrOff - 2 || gr.top > window.innerHeight * 0.5)){
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var hdrSec = document.querySelector('.custom-mm7v1');
            var hh = hdrSec ? hdrSec.getBoundingClientRect().height : hdrOff;
            var target = Math.max(0, gr.top + window.pageYOffset - hh - 8);
            var done = false, go = function(){ if(done) return; done = true; window.removeEventListener('scrollend', go); cur = v; picked = true; paint(); };
            if(reduce){ window.scrollTo(0, target); go(); return; }
            window.addEventListener('scrollend', go);
            setTimeout(go, 900);
            window.scrollTo({ top: target, behavior: 'smooth' });
            return;
          }
          cur = v; picked = true; paint();
        });
      });

      /* THE PACKAGING RAIL DRAGS (client 2026-08-22: "slider not working by drag and laptop
         track"). It is a native overflow-x scroller, and a native scroller answers a touch swipe
         but never a MOUSE drag — so on a laptop the row looked stuck. This adds the two gestures
         the browser does not give for free: a 1:1 pointer drag, and a horizontal wheel mapped to
         scrollLeft for trackpads. The 4px threshold before capture is what keeps a plain click on
         a packaging card from being swallowed by the drag. */
      var rail = root.querySelector('.custom-prd7k9__sizes');
      if(rail){
        var rDown = false, rMoved = false, rX = 0, rLeft = 0;
        rail.addEventListener('pointerdown', function(e){
          if(e.button !== 0) return;
          if(e.pointerType !== 'mouse') return;   /* a finger uses the native scroller, so a vertical swipe stays a page scroll */
          rDown = true; rMoved = false; rX = e.clientX; rLeft = rail.scrollLeft;
        });
        rail.addEventListener('pointermove', function(e){
          if(!rDown) return;
          var dx = e.clientX - rX;
          if(!rMoved && Math.abs(dx) > 4){ rMoved = true; try{ rail.setPointerCapture(e.pointerId); }catch(err){} rail.style.cursor = 'grabbing'; }
          if(rMoved){ rail.scrollLeft = rLeft - dx; e.preventDefault(); }
        });
        var railUp = function(e){
          if(!rDown) return;
          rDown = false; rail.style.cursor = '';
          if(rMoved && e){ try{ rail.releasePointerCapture(e.pointerId); }catch(err){} }
          setTimeout(function(){ rMoved = false; }, 0);
        };
        rail.addEventListener('pointerup', railUp);
        rail.addEventListener('pointercancel', railUp);
        rail.addEventListener('click', function(e){ if(rMoved){ e.preventDefault(); e.stopPropagation(); } }, true);
        rail.addEventListener('wheel', function(e){
          var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : 0;
          if(!d) return;
          rail.scrollLeft += d; e.preventDefault();
        }, { passive: false });
      }

      /* ---- wishlist ----
         The list itself lives in assets/candy-wishlist.js (loaded site-wide from candy-head),
         so this is only the button: read the state, toggle it, and redraw whenever the list
         changes anywhere — which covers another tab, and covers a login folding the guest list
         into the account's.

         It used to own the storage: a bare array of handles under `c4u_wish`, read and written
         inline right here. That worked for one button on one page and nothing else, and it had
         no notion of WHOSE list it was — sign in on a shared laptop and you inherited the last
         visitor's hearts. The store handles both; candy-wishlist.js migrates the old key on
         first load, so nobody's existing saves are dropped. */
      var wish = root.querySelector('[data-wish]');
      if(wish && window.candyWish){
        var wh = wish.getAttribute('data-handle');
        var snap = null;
        try{ snap = JSON.parse(wish.getAttribute('data-snap')); }catch(e){ snap = { h: wh }; }
        var paintWish = function(){
          /* candy-wishlist.js keeps an append-only subs array, so a re-rendered band would
             otherwise leave this closure behind holding a detached button for ever. */
          if(!wish.isConnected){ if(window.candyWish.off) window.candyWish.off(paintWish); return; }
          var on = window.candyWish.has(wh);
          wish.setAttribute('aria-pressed', on ? 'true' : 'false');
          wish.setAttribute('aria-label', on ? 'Saved to wishlist — tap to remove' : 'Save to wishlist');
        };
        window.candyWish.on(paintWish);
        root.__c4uUnload = function(){ if(window.candyWish && window.candyWish.off) window.candyWish.off(paintWish); };
        wish.addEventListener('click', function(){
          window.candyWish.toggle(snap || { h: wh });
          /* the store notifies paintWish, so the state is not set twice */
          wish.classList.remove('custom-prd7k9__wish--pop');
          void wish.offsetWidth;                       /* restart the keyframe on a re-press */
          wish.classList.add('custom-prd7k9__wish--pop');
        });
      }

      root.querySelectorAll('.custom-prd7k9__qbtn').forEach(function(b){
        b.addEventListener('click', function(){
          qty = Math.max(1, qty + parseInt(b.getAttribute('data-q'), 10));
          if(qtyEl) qtyEl.textContent = qty;
        });
      });

      /* ---- gallery slider (client 2026-08-22: "add slider to the media gallery ... best
         lightweight and smooth, drag and laptop track support") ----
         One translate3d on the track and nothing else. There is no library and no per-frame
         layout read: the stage width is measured once when a gesture starts and again only if a
         resize actually changes it, so every frame in between is a single transform write. */
      var track  = root.querySelector('[data-track]');
      var slides = track ? track.querySelectorAll('.custom-prd7k9__slide') : [];
      var nativeGallery = root.querySelector('.custom-prd7k9__gallery[data-native-ratio]');
      /* a product whose every photo is a pack shot (jelly-belly-grape) has pack slides IN the gallery,
         held at opacity 0 until they fill (candy-pack.css), so the opening slide fills on load */
      if(slides[0] && slides[0].hasAttribute('data-packshot')){
        if(window.c4uFill) window.c4uFill(slides[0]); else slides[0].classList.add('c4u-fill--go');
      }
      /* PACK SHOTS WARM UP IN THE BACKGROUND (Arsalan 2026-09-28: "filling animation smooth and fast"). The parked
         pack slides are loading="lazy", so the first click on a packaging waited ~0.5-1.4s for its photo before the
         fill could start. Once the page itself has loaded they are fetched quietly, so a click fills at once. */
      (function warmPacks(){
        function go(){ setTimeout(function(){
          Array.prototype.forEach.call(slides, function(s){
            var im = s.hasAttribute('data-packshot') && s.querySelector('img');
            if(im && im.loading === 'lazy') im.loading = 'eager';
          });
        }, 500); }
        if(document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
      })();
      var slideI = 0, stageW = 0, galleryInView = true, lastFillI = 0;
      /* The slides after data-navlen are the variant pack shots, parked out of reach (user
         2026-09-19: "main gallery hide hogi variant k img or thumbnail"). They are real slides so
         the packaging swap is the same translate as everything else, but the arrows, the drag and
         the thumb rail all stop at navLen — only a packaging click jumps past it. */
      var navLen   = track ? (parseInt(track.getAttribute('data-navlen'), 10) || slides.length) : 0;
      var packBase = track ? (parseInt(track.getAttribute('data-packbase'), 10) || navLen) : 0;
      if(navLen < 1 || navLen > slides.length) navLen = slides.length;

      /* THE STEP IS A PERCENTAGE, NOT PIXELS (client 2026-08-22: "slider showing next slide little
         bit on right"). The stage is a vw box, so its width is fractional — 538.83px here. Reading
         that back into JS and writing it out as a px translate loses the last fraction, and the
         missing sliver is exactly what showed as a hairline of the next image down the right edge.
         `calc(-100% * i)` is resolved by the compositor against the same fractional width the
         layout used, so the seam lands precisely on the stage edge at any zoom or window size.
         The px term is only the live drag offset, which does not need to be exact. */
      function trackW(){ return track.getBoundingClientRect().width; }
      function paintTrack(i, dxPx, animate){
        if(!track) return;
        track.style.transition = animate ? 'transform .45s cubic-bezier(.16,1,.3,1)' : 'none';
        track.style.transform  = 'translate3d(calc(' + (-i * 100) + '% + ' + ((dxPx || 0) / window.innerWidth * 100) + 'vw),0,0)';
      }
      /* n is 1-based — the thumbs and the variant's media position both count from 1 */
      function showSlide(n, animate){
        if(!slides.length) return;
        closeZoom();                       /* a zoomed picture never survives a change of slide */
        slideI = Math.max(0, Math.min(slides.length - 1, (parseInt(n, 10) || 1) - 1));
        if(nativeGallery){
          var mediaRatio = parseFloat(slides[slideI].getAttribute('data-media-ratio'));
          if(mediaRatio > 0) nativeGallery.style.setProperty('--gallery-ratio', mediaRatio);
        }
        stageW = trackW();
        paintTrack(slideI, 0, animate !== false);
        root.querySelectorAll('[data-snav]').forEach(function(b){
          var fwd = parseInt(b.getAttribute('data-snav'), 10) > 0;
          b.disabled = fwd ? slideI >= navLen - 1 : slideI <= 0;
        });
        var pos = String(slideI + 1);
        slides.forEach(function(s){
          var on = s.getAttribute('data-slide') === pos;
          s.classList.toggle('custom-prd7k9__slide--on', on);
          var vid = s.querySelector('video');
          if(vid && (!on || !galleryInView)){ vid.pause(); }
        });
        root.querySelectorAll('.custom-prd7k9__thumb').forEach(function(t){
          t.classList.toggle('custom-prd7k9__thumb--on', t.getAttribute('data-thumb') === pos);
        });
        keepThumbInView();
        /* FILL UP (user 2026-09-20). A parked pack-shot slide fills when its packaging is picked.
           Only on a real change of slide: showSlide() also runs on resize and when the gallery
           scrolls back into view, and the pack must not refill every time that happens. */
        if(slideI !== lastFillI){
          lastFillI = slideI;
          var fs = slides[slideI];
          if(fs && fs.hasAttribute('data-packshot')){
            if(window.c4uFill) window.c4uFill(fs); else fs.classList.add('c4u-fill--go');
          }
        }
      }
      root.querySelectorAll('.custom-prd7k9__thumb').forEach(function(t){
        t.addEventListener('click', function(){ showSlide(t.getAttribute('data-thumb')); });
      });
      root.querySelectorAll('[data-snav]').forEach(function(b){
        b.addEventListener('click', function(){
          /* clamped to navLen so the arrows never page into the parked pack shots */
          showSlide(Math.min(navLen, slideI + 1 + parseInt(b.getAttribute('data-snav'), 10)));
        });
      });

      /* Product videos start only from their native Play control. Returning to a page,
         changing tabs or selecting a gallery slide must never resume them automatically. */
      function pauseProductGallery(){
        slides.forEach(function(s){
          var video = s.querySelector('video');
          if(video) video.pause();
          s.querySelectorAll('iframe').forEach(function(frame){
            try{
              var origin = new URL(frame.src, location.href).origin;
              frame.contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), origin);
              frame.contentWindow.postMessage(JSON.stringify({method:'pause'}), origin);
            }catch(ignore){}
          });
        });
      }
      window.addEventListener('pagehide', pauseProductGallery);
      window.addEventListener('pageshow', pauseProductGallery);
      document.addEventListener('visibilitychange', function(){ if(document.hidden) pauseProductGallery(); });

      /* Keep offscreen gallery media paused; visibility alone never starts playback. */
      if('IntersectionObserver' in window){
        var galleryStage = root.querySelector('.custom-prd7k9__stage');
        if(galleryStage){
          new IntersectionObserver(function(entries){
            galleryInView = !!entries[0].isIntersecting;
            if(galleryInView) showSlide(slideI + 1, false);
            else slides.forEach(function(s){ var v = s.querySelector('video'); if(v) v.pause(); });
          }, { rootMargin: '120px 0px' }).observe(galleryStage);
        }
      }

      /* ---- IN-PLACE ZOOM (user 2026-09-20: "zoom should work on click like this", pointing at the
         NanoGreens page in the biopharmasci build, sections/CWC_product_hero_buy_box_v3.liquid) ----
         The magnifier used to open the picture in a lightbox over the page. It now does what that
         build does: the picture scales up INSIDE its own frame, round the point that was clicked,
         follows the pointer while it is zoomed, and a second click, the button again, a change of
         slide or leaving the frame puts it back. Same three moves as the reference, on this
         gallery's own slider: that one reads its slide from a scroll position, this one from
         slideI, and this one has to stand the drag down while zoomed or a pan would turn the page.

         Only an <img> slide zooms; a video keeps its own controls. The transform itself is CSS
         (.custom-prd7k9__slide--zoom in candy-product.css), this only sets the class and the
         --zoom-x / --zoom-y origin. */
      var zoomedSlide = null, zoomBtn = root.querySelector('[data-zoom]'), zoomDownX = 0, zoomDownY = 0;
      function zoomImg(slide){ return slide ? slide.querySelector('.custom-prd7k9__img') : null; }
      function zoomOrigin(slide, x, y){
        var im = zoomImg(slide);
        if(!im) return;
        im.style.setProperty('--zoom-x', x + '%');
        im.style.setProperty('--zoom-y', y + '%');
      }
      function closeZoom(){
        if(!zoomedSlide) return;
        zoomedSlide.classList.remove('custom-prd7k9__slide--zoom');
        zoomedSlide = null;
        if(zoomBtn){
          zoomBtn.classList.remove('custom-prd7k9__zoom--on');
          zoomBtn.setAttribute('aria-pressed', 'false');
          zoomBtn.setAttribute('aria-label', 'Zoom image');
        }
      }
      function openZoom(slide, x, y){
        var im = zoomImg(slide);
        if(!im) return;
        closeZoom();
        /* an entrance animation that ended on `transform: none` with fill-mode both would hold
           that transform for ever and the zoom could never apply; it has done its job by now */
        im.style.animation = 'none';
        zoomOrigin(slide, x, y);
        slide.classList.add('custom-prd7k9__slide--zoom');
        zoomedSlide = slide;
        if(zoomBtn){
          zoomBtn.classList.add('custom-prd7k9__zoom--on');
          zoomBtn.setAttribute('aria-pressed', 'true');
          zoomBtn.setAttribute('aria-label', 'Zoom out');
        }
      }
      function zoomPct(e, el){
        var r = el.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
        var y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
        return [x.toFixed(1), y.toFixed(1)];
      }
      /* A FINGER DRAGS THE PICTURE, IT DOES NOT AIM IT (Arsalan 2026-09-28: "zoom on mobile looks glitchy").
         The mouse rule - the zoom point follows the pointer - made a zoomed picture jump the moment a finger
         landed (the point snapped to wherever the thumb touched) and pan the wrong way (moving right showed
         more of the right). On touch the picture now moves WITH the finger from where it is: the origin
         shifts by -distance / (scale - 1), clamped to the photo, and the zoomed slide takes touch-action:
         none in the CSS so the same drag no longer scrolls the page underneath it. Tap still zooms out. */
      var ZOOM_SCALE = 2.2, panX0 = 0, panY0 = 0, panO = null;
      function zoomOriginNow(slide){
        var im = zoomImg(slide);
        var x = parseFloat(im && im.style.getPropertyValue('--zoom-x')), y = parseFloat(im && im.style.getPropertyValue('--zoom-y'));
        return [isNaN(x) ? 50 : x, isNaN(y) ? 50 : y];   /* 0% is a real edge, not "unset" */
      }
      if(track){
        track.addEventListener('pointerdown', function(e){
          zoomDownX = e.clientX; zoomDownY = e.clientY;
          if(zoomedSlide && e.pointerType !== 'mouse'){ panX0 = e.clientX; panY0 = e.clientY; panO = zoomOriginNow(zoomedSlide); }
        });
        function panEnd(){ panO = null; }
        track.addEventListener('pointerup', panEnd);
        track.addEventListener('pointercancel', panEnd);
        track.addEventListener('click', function(e){
          /* a press that travelled is a swipe, not a click; the drag code swallows most of those
             before they get here, this catches the ones that stopped short of changing slide */
          if(Math.abs(e.clientX - zoomDownX) > 6 || Math.abs(e.clientY - zoomDownY) > 6) return;
          if(e.target.closest && e.target.closest('video, iframe, [data-zoom], [data-snav]')) return;
          var slide = slides[slideI];
          if(!zoomImg(slide)) return;
          if(zoomedSlide === slide){ closeZoom(); return; }
          var p = zoomPct(e, slide);
          openZoom(slide, p[0], p[1]);
        });
        /* pointermove, not mousemove: a finger dragged across a zoomed picture pans it too */
        track.addEventListener('pointermove', function(e){
          if(!zoomedSlide) return;
          if(e.pointerType !== 'mouse'){
            if(!panO) return;
            var r = zoomedSlide.getBoundingClientRect(), k = 100 / (ZOOM_SCALE - 1);
            var nx = Math.max(0, Math.min(100, panO[0] - (e.clientX - panX0) / r.width * k));
            var ny = Math.max(0, Math.min(100, panO[1] - (e.clientY - panY0) / r.height * k));
            zoomOrigin(zoomedSlide, nx.toFixed(2), ny.toFixed(2));
            e.preventDefault();
            return;
          }
          var p = zoomPct(e, zoomedSlide);
          zoomOrigin(zoomedSlide, p[0], p[1]);
        });
        var zoomStage = root.querySelector('.custom-prd7k9__stage');
        /* mouse only: a phone fires a synthetic mouseleave when the next tap lands elsewhere */
        if(zoomStage) zoomStage.addEventListener('pointerleave', function(e){ if(e.pointerType === 'mouse') closeZoom(); });
      }
      if(zoomBtn){
        zoomBtn.setAttribute('aria-pressed', 'false');
        zoomBtn.addEventListener('click', function(e){
          /* stopPropagation: candy-product-core.js still listens on document for [data-zoom] and
             opens the lightbox, which is now only the fallback if this band never binds */
          e.preventDefault(); e.stopPropagation();
          if(zoomedSlide){ closeZoom(); return; }
          openZoom(slides[slideI], 50, 50);
        });
      }

      (function stageDrag(){
        if(!track || slides.length < 2) return;
        var down = false, moved = false, x0 = 0, y0 = 0, dx = 0, base = 0, dir = '';

        track.addEventListener('pointerdown', function(e){
          if(e.button !== 0) return;
          if(zoomedSlide) return;            /* zoomed: the pointer pans the picture, it does not turn the page */
          /* the zoom button and the arrows are buttons, and an embedded iframe owns its own
             pointer, so none of those start a drag */
          if(e.target.closest && e.target.closest('iframe, [data-zoom], [data-snav]')) return;
          /* a <video> is different: its picture drags like any other slide, but the bottom strip
             is the native control bar and has to keep the play head, mute and fullscreen */
          var vEl = e.target.closest && e.target.closest('video');
          if(vEl){
            var vr = vEl.getBoundingClientRect();
            if(e.clientY > vr.bottom - 48) return;
          }
          down = true; moved = false; dx = 0; dir = '';
          x0 = e.clientX; y0 = e.clientY;
          stageW = trackW(); base = slideI;
          paintTrack(base, 0, false);
        });

        track.addEventListener('pointermove', function(e){
          if(!down) return;
          var ddx = e.clientX - x0, ddy = e.clientY - y0;
          /* lock the axis on the first real movement: a vertical drag has to stay a page scroll */
          if(!dir){
            if(Math.abs(ddx) < 5 && Math.abs(ddy) < 5) return;
            dir = Math.abs(ddx) > Math.abs(ddy) ? 'x' : 'y';
            if(dir === 'x'){
              moved = true;
              track.classList.add('custom-prd7k9__track--drag');
              try{ track.setPointerCapture(e.pointerId); }catch(err){}
            }
          }
          if(dir !== 'x') return;
          dx = ddx;
          /* rubber-band at the ends so the track can never be pulled into empty space */
          if((slideI === 0 && dx > 0) || (slideI >= navLen - 1 && dx < 0)) dx *= 0.35;
          paintTrack(base, dx, false);
          e.preventDefault();
        });

        function endDrag(e){
          if(!down) return;
          down = false;
          track.classList.remove('custom-prd7k9__track--drag');
          if(moved && e){ try{ track.releasePointerCapture(e.pointerId); }catch(err){} }
          if(dir !== 'x'){ moved = false; return; }
          /* a tenth of the stage is enough to commit — the client's standing note on the other
             carousels is that a short nudge must switch, not a full-width swipe */
          var step = Math.abs(dx) > stageW * 0.1 ? (dx < 0 ? 1 : -1) : 0;
          /* a swipe stops at the last real picture; the pack shots live past navLen */
          showSlide(Math.min(navLen, slideI + 1 + step));
          setTimeout(function(){ moved = false; }, 0);
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('dragstart', function(e){ e.preventDefault(); });
        track.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);

        /* NO wheel listener here on purpose. The trackpad gesture is already handled site-wide by
           the shim in candy-head.liquid: it finds the nearest ancestor with touch-action: pan-y —
           this track — and replays a horizontal wheel as pointerdown / pointermove / pointerup, so
           the drag code above IS the trackpad support. A local wheel handler as well made every
           two-finger swipe count twice and skip a slide. */

        /* width-only guard: on a phone the URL bar changing height fires resize constantly, and
           re-measuring there would jump the track mid-scroll */
        CP.onWindow(root, 'resize', function(){
          if(trackW() === stageW) return;
          showSlide(slideI + 1, false);
        });
        /* initialise: sets stageW and, with it, the arrows' disabled state on first paint */
        showSlide(1, false);
      })();

      /* ---- vertical thumb rail (client 2026-08-20) ----
         Two jobs, both no-ops unless the column actually scrolls, which is why nothing
         here needs a breakpoint check: on mobile and in the split / immersive layouts the
         thumbs are a wrapping row with `overflow: visible`, so scrollHeight equals
         clientHeight, the arrows stay hidden and every function below returns early. */
      var thumbStrip = root.querySelector('[data-thumbs]');
      function thumbOverflow(){
        return thumbStrip ? thumbStrip.scrollHeight - thumbStrip.clientHeight > 1 : false;
      }
      /* selecting a size can jump the gallery to that variant's media (see paint), and the
         matching thumb may be outside the four-thumb window — scroll the minimum needed to
         bring it in rather than centring it, so the column moves as little as possible */
      function keepThumbInView(){
        if(!thumbStrip) return;
        var act = thumbStrip.querySelector('.custom-prd7k9__thumb--on');
        if(!act) return;
        /* Mobile uses a horizontal, no-wrap thumbnail rail. Keep arrow/variant changes
           visible without scrollIntoView(), which can also move the whole page vertically. */
        if(thumbStrip.scrollWidth - thumbStrip.clientWidth > 1){
          var left = act.offsetLeft;
          if(left < thumbStrip.scrollLeft){
            thumbStrip.scrollLeft = left;
          } else if(left + act.offsetWidth > thumbStrip.scrollLeft + thumbStrip.clientWidth){
            thumbStrip.scrollLeft = left + act.offsetWidth - thumbStrip.clientWidth;
          }
          return;
        }
        if(!thumbOverflow()) return;
        var top = act.offsetTop;
        if(top < thumbStrip.scrollTop){
          thumbStrip.scrollTop = top;
        } else if(top + act.offsetHeight > thumbStrip.scrollTop + thumbStrip.clientHeight){
          thumbStrip.scrollTop = top + act.offsetHeight - thumbStrip.clientHeight;
        }
      }
      (function thumbRail(){
        if(!thumbStrip) return;
        var navs = root.querySelectorAll('[data-thumbnav]');
        if(!navs.length) return;
        /* one thumb + one gap, measured off the rendered boxes rather than recomputed
           from the vw values — the two must not be able to disagree */
        function pitch(){
          var a = thumbStrip.children[0], b = thumbStrip.children[1];
          if(!a) return 0;
          if(b && b.offsetTop !== a.offsetTop) return Math.abs(b.offsetTop - a.offsetTop);
          return a.offsetHeight;
        }
        /* Manual wheel/drag input used to stop at any pixel, leaving the first and
           last visible thumbnail clipped by the window. Clicking then appeared to
           "fix" it because keepThumbInView() moved the active item. Settle every
           manual move onto the nearest complete thumb pitch instead. */
        var snapTimer = null;
        function snapThumbs(){
          if(!thumbOverflow()) return;
          var p = pitch();
          if(!p) return;
          var max = Math.max(0, thumbStrip.scrollHeight - thumbStrip.clientHeight);
          var target = Math.max(0, Math.min(max, Math.round(thumbStrip.scrollTop / p) * p));
          thumbStrip.scrollTop = target;
        }
        function queueThumbSnap(){
          clearTimeout(snapTimer);
          snapTimer = setTimeout(snapThumbs, 90);
        }
        function sync(){
          var over = thumbOverflow();
          var max = thumbStrip.scrollHeight - thumbStrip.clientHeight;
          thumbStrip.classList.toggle('custom-prd7k9__thumbs--scroll', over);
          navs.forEach(function(n){
            n.hidden = !over;
            var up = parseInt(n.getAttribute('data-thumbnav'), 10) < 0;
            n.classList.toggle('custom-prd7k9__thumbnav--off',
              up ? thumbStrip.scrollTop <= 1 : thumbStrip.scrollTop >= max - 1);
          });
        }
        navs.forEach(function(n){
          n.addEventListener('click', function(){
            /* Start from a whole step even if a previous gesture ended between
               items; scroll-behavior: smooth on the strip does the easing. */
            var p = pitch();
            var max = Math.max(0, thumbStrip.scrollHeight - thumbStrip.clientHeight);
            var step = Math.round(thumbStrip.scrollTop / p) + parseInt(n.getAttribute('data-thumbnav'), 10);
            thumbStrip.scrollTop = Math.max(0, Math.min(max, step * p));
          });
        });
        thumbStrip.addEventListener('scroll', sync, { passive: true });

        /* the column also drags, and a trackpad's wheel pages it instead of the window — same two
           gestures the stage got, turned on their side. Both are no-ops while it does not overflow. */
        var tDown = false, tMoved = false, tY = 0, tTop = 0;
        thumbStrip.addEventListener('pointerdown', function(e){
          if(e.button !== 0 || !thumbOverflow()) return;
          tDown = true; tMoved = false; tY = e.clientY; tTop = thumbStrip.scrollTop;
        });
        thumbStrip.addEventListener('pointermove', function(e){
          if(!tDown) return;
          var dy = e.clientY - tY;
          if(!tMoved && Math.abs(dy) > 4){
            tMoved = true;
            /* scroll-behavior: smooth is what eases the arrow clicks; against a 1:1 drag it
               lags a frame behind the pointer, so it comes off for the duration of the drag */
            thumbStrip.style.scrollBehavior = 'auto';
            thumbStrip.style.cursor = 'grabbing';
            try{ thumbStrip.setPointerCapture(e.pointerId); }catch(err){}
          }
          if(tMoved){ thumbStrip.scrollTop = tTop - dy; e.preventDefault(); }
        });
        var thumbUp = function(e){
          if(!tDown) return;
          tDown = false;
          thumbStrip.style.scrollBehavior = '';
          thumbStrip.style.cursor = '';
          if(tMoved && e){ try{ thumbStrip.releasePointerCapture(e.pointerId); }catch(err){} }
          if(tMoved) snapThumbs();
          setTimeout(function(){ tMoved = false; }, 0);
        };
        thumbStrip.addEventListener('pointerup', thumbUp);
        thumbStrip.addEventListener('pointercancel', thumbUp);
        /* a drag that ends on a thumb must not also select it */
        thumbStrip.addEventListener('click', function(e){ if(tMoved){ e.preventDefault(); e.stopPropagation(); } }, true);

        thumbStrip.addEventListener('wheel', function(e){
          /* vertical intent only — a horizontal wheel here belongs to the head-snippet shim */
          if(!thumbOverflow() || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          var d = e.deltaY;
          if(!d) return;
          var max = thumbStrip.scrollHeight - thumbStrip.clientHeight;
          /* Hand the gesture back to the page only when the rail is ALREADY at
             that end. Previously an overshooting wheel delta was rejected while
             still between items, permanently leaving a clipped thumbnail. */
          if((d < 0 && thumbStrip.scrollTop <= 1) ||
             (d > 0 && thumbStrip.scrollTop >= max - 1)) return;
          var next = Math.max(0, Math.min(max, thumbStrip.scrollTop + d));
          thumbStrip.style.scrollBehavior = 'auto';
          thumbStrip.scrollTop = next;
          thumbStrip.style.scrollBehavior = '';
          queueThumbSnap();
          e.preventDefault();
        }, { passive: false });

        var trz;
        CP.onWindow(root, 'resize', function(){ clearTimeout(trz); trz = setTimeout(sync, 100); });
        /* the thumbs are lazy images, so the column's real height only settles once they
           land — re-check then or a scrollable rail can start with no arrows */
        CP.onWindow(root, 'load', sync);
        sync();
      })();

      /* ---- native gift upload / written message ---- */
      var giftBox = root.querySelector('[data-gift]');
      var giftFields = root.querySelector('[data-gift-fields]');
      var giftMode = 'upload', giftFile = null, giftChecking = false, giftSelection = 0;
      var addPending = false, addLocked = false;
      var giftStatus = root.querySelector('[data-gift-status]');
      var cartStatus = root.querySelector('[data-cart-status]');
      var giftClear = root.querySelector('[data-gift-clear]');
      var cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      if(cartRoot.charAt(cartRoot.length - 1) !== '/') cartRoot += '/';
      if(!cartStatus && atcBtn){
        cartStatus = document.createElement('p');
        cartStatus.setAttribute('data-cart-status', '');
        cartStatus.setAttribute('role', 'status');
        cartStatus.setAttribute('aria-live', 'polite');
        atcBtn.parentNode.insertBefore(cartStatus, atcBtn.nextSibling);
      }
      function giftMessage(text, failed){
        if(!giftStatus) return;
        giftStatus.textContent = text;
        giftStatus.setAttribute('data-state', failed ? 'error' : 'info');
      }
      function cartMessage(text, review){
        if(!cartStatus) return;
        cartStatus.textContent = text;
        if(review){
          var link = document.createElement('a');
          link.href = cartRoot + 'cart';
          link.textContent = ' Review your basket';
          cartStatus.appendChild(link);
        }
      }
      function syncAddControls(){
        var checking = giftChecking && giftBox && giftBox.checked && giftMode === 'upload';
        var disabled = !cur || !cur.available || addPending || addLocked || checking;
        var text = addPending ? 'Adding to basket...' : addLocked ? 'Review your basket' : checking ? (giftShrinking ? 'Preparing video...' : 'Checking video...') : atcLabel();
        [atcBtn, root.querySelector('[data-bar-atc]')].forEach(function(button){
          if(!button) return;
          button.disabled = !!disabled;
          button.classList.toggle('custom-prd7k9__atc--busy', !!addPending);
          button.setAttribute('aria-busy', addPending ? 'true' : 'false');
          if(addPending) button.dataset.busy = '1'; else delete button.dataset.busy;
          if(button === atcBtn){ if(atcT) atcT.textContent = text; }
          else button.textContent = text;
        });
        root.querySelectorAll('[data-gift], [data-gift-opt], [data-gift-file], [data-gift-clear], [data-gift-msg], [data-ribbon-on], [data-ribbon-text]').forEach(function(control){
          control.disabled = !!addPending || !!addLocked;
        });
      }
      if(giftBox && giftFields) giftBox.addEventListener('change', function(){
        giftFields.hidden = !giftBox.checked;
        syncAddControls();
      });
      root.querySelectorAll('[data-gift-opt]').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(addPending || addLocked) return;
          giftMode = btn.getAttribute('data-gift-opt');
          root.querySelectorAll('[data-gift-opt]').forEach(function(b){
            b.classList.toggle('custom-prd7k9__gift-opt--on', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          root.querySelectorAll('[data-gift-pane]').forEach(function(p){ p.hidden = p.getAttribute('data-gift-pane') !== giftMode; });
          if(giftMode === 'write'){
            resetGiftFile();
            giftMessage('Write your gift message below. A video is not included with this option.');
          }else{
            giftMessage(giftFile ? 'Video selected. It will upload when you add this gift to your basket.' : 'Choose a video. It will upload when you add this gift to your basket.');
          }
          syncAddControls();
        });
      });
      var drop = root.querySelector('[data-gift-drop]');
      var fileIn = root.querySelector('[data-gift-file]');
      var dropT = root.querySelector('[data-gift-drop-t]');
      var dropDefault = dropT ? dropT.textContent : 'Choose an MP4 video';
      /* GIFT VIDEO SIZE (Arsalan 2026-10-27: "limit 100mb tak karo"). Shopify's basket takes about 20 MB in one
         upload (20,500,000 bytes went through, 20 MiB came back 413). A video up to 100 MB can be chosen; one over
         19 MB is made smaller in this browser first by assets/c4u-video-shrink.js, which loads only then. */
      var giftMaxBytes = 19000000, giftPickBytes = 100 * 1024 * 1024;
      var shrinkSrc = giftFields ? giftFields.getAttribute('data-gift-shrink') : '';
      var shrinkLoad = null, shrinkStop = null, giftShrinking = false;
      function loadShrink(){
        if(window.c4uShrinkVideo) return Promise.resolve(window.c4uShrinkVideo);
        if(!shrinkSrc) return Promise.reject(new Error('Choose a video up to 19 MB.'));
        if(!shrinkLoad) shrinkLoad = new Promise(function(resolve, reject){
          var s = document.createElement('script');
          s.src = shrinkSrc;
          s.async = true;
          s.onload = function(){
            if(window.c4uShrinkVideo) resolve(window.c4uShrinkVideo);
            else{ shrinkLoad = null; reject(new Error('We could not get your video ready. Reload the page and try again.')); }
          };
          s.onerror = function(){
            shrinkLoad = null;
            if(s.parentNode) s.parentNode.removeChild(s);
            reject(new Error('We could not get your video ready. Check your connection and try again.'));
          };
          document.head.appendChild(s);
        });
        return shrinkLoad;
      }
      function resetGiftFile(){
        giftSelection++;
        giftChecking = false;
        giftShrinking = false;
        if(shrinkStop){ shrinkStop.abort(); shrinkStop = null; }
        giftFile = null;
        if(fileIn) fileIn.value = '';
        if(dropT) dropT.textContent = dropDefault;
        if(giftClear) giftClear.hidden = true;
        syncAddControls();
      }
      function checkGiftPlayback(file){
        return new Promise(function(resolve, reject){
          var video = document.createElement('video');
          var objectUrl = URL.createObjectURL(file);
          var settled = false;
          var timer = setTimeout(function(){ finish(new Error('We could not check this video. Try a shorter video.')); }, 15000);
          function finish(error){
            if(settled) return;
            settled = true;
            clearTimeout(timer);
            video.oncanplay = video.onerror = null;
            video.pause();
            video.removeAttribute('src');
            video.load();
            URL.revokeObjectURL(objectUrl);
            if(error) reject(error); else resolve();
          }
          video.preload = 'auto';
          video.muted = true;
          video.playsInline = true;
          video.oncanplay = function(){
            if(video.videoWidth > 0 && video.videoHeight > 0 && Number.isFinite(video.duration) && video.duration > 0) finish();
            else finish(new Error('This file does not contain a playable video. Choose another video.'));
          };
          video.onerror = function(){ finish(new Error('This browser cannot play this video. Choose another video or export it as an MP4.')); };
          video.src = objectUrl;
          video.load();
        });
      }
      function setGiftFile(f){
        if(!f || addPending || addLocked) return;
        resetGiftFile();
        /* MOV is how an iPhone hands over a camera-roll video; Shopify stores it and the gift video
           page plays it (checked 2026-10-21). The playback check below still has to pass. */
        if(!/\.(mp4|mov)$/i.test(f.name) || (f.type && f.type !== 'video/mp4' && f.type !== 'video/quicktime')){
          giftMessage('Choose an MP4 or MOV video. Other formats are not supported yet.', true);
          return;
        }
        if(!f.size || f.size > giftPickBytes){
          giftMessage('Choose a video up to 100 MB.', true);
          return;
        }
        var selection = giftSelection;
        giftChecking = true;
        if(dropT) dropT.textContent = f.name;
        if(giftClear) giftClear.hidden = false;
        giftMessage('Checking your video. It has not been uploaded yet.');
        syncAddControls();
        checkGiftPlayback(f).then(function(){
          if(selection !== giftSelection || f.size <= giftMaxBytes) return f;
          /* too big for one upload: a smaller copy is made here, and that copy is what goes up */
          giftShrinking = true;
          syncAddControls();
          giftMessage('Making your video smaller so it can upload. Keep this page open.');
          var stop = shrinkStop = window.AbortController ? new AbortController() : null;
          return loadShrink().then(function(shrink){
            if(selection !== giftSelection) return null;
            return shrink(f, {
              maxBytes: giftMaxBytes - 1000000,
              signal: stop ? stop.signal : null,
              onProgress: function(p){
                if(selection === giftSelection) giftMessage('Making your video smaller: ' + Math.round(p * 100) + '%. Keep this page open.');
              }
            });
          }).then(function(small){
            if(!small || selection !== giftSelection) return null;
            return checkGiftPlayback(small).then(function(){ return small; });
          });
        }).then(function(ready){
          if(!ready || selection !== giftSelection) return;
          giftChecking = false;
          giftShrinking = false;
          shrinkStop = null;
          giftFile = ready; /* Preserve the actual File for both picker and drop (or the smaller copy made from it). */
          giftMessage(ready === f ? 'Video selected. It will upload when you add this gift to your basket.'
            : 'Video ready, made smaller to ' + (ready.size / 1000000).toFixed(1) + ' MB. It will upload when you add this gift to your basket.');
          syncAddControls();
        }).catch(function(error){
          if(selection !== giftSelection) return;
          resetGiftFile();
          giftMessage(error && error.message ? error.message : 'We could not get this video ready. Choose another video.', true);
        });
      }
      if(giftClear) giftClear.addEventListener('click', function(){
        if(addPending || addLocked) return;
        resetGiftFile();
        giftMessage('Video removed. Choose a video before adding this gift to your basket.');
      });
      if(drop){
        ['dragover', 'dragenter'].forEach(function(ev){
          drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.add('custom-prd7k9__gift-drop--over'); });
        });
        ['dragleave', 'drop'].forEach(function(ev){
          drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.remove('custom-prd7k9__gift-drop--over'); });
        });
        drop.addEventListener('drop', function(e){
          if(!addPending && !addLocked && e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) setGiftFile(e.dataTransfer.files[0]);
        });
      }
      if(fileIn) fileIn.addEventListener('change', function(){ if(fileIn.files && fileIn.files[0]) setGiftFile(fileIn.files[0]); });

      /* ---- printed ribbon (Arsalan 2026-10-27; Ian's spec option A, +£2.99) ----
         Ticking it opens a line for their words, drawn on a ribbon as they type. On Add to basket the ribbon goes in
         as its own product, linked to this gift line by a shared _Ribbon ID, so the basket can drop it with the gift.
         A ribbon is enough of a gift on its own: with one, the video or note becomes optional. */
      var ribbonBox = root.querySelector('[data-ribbon]');
      var ribbonOn = root.querySelector('[data-ribbon-on]');
      var ribbonFields = root.querySelector('[data-ribbon-fields]');
      var ribbonIn = root.querySelector('[data-ribbon-text]');
      var ribbonShow = root.querySelector('[data-ribbon-show]');
      var ribbonCount = root.querySelector('[data-ribbon-count]');
      var ribbonMax = ribbonIn && ribbonIn.maxLength > 0 ? ribbonIn.maxLength : 30;
      function ribbonWords(){
        return ribbonOn && ribbonOn.checked && ribbonIn ? ribbonIn.value.replace(/\s+/g, ' ').trim().slice(0, ribbonMax) : '';
      }
      function drawRibbon(){
        if(!ribbonIn) return;
        var words = ribbonIn.value.replace(/\s+/g, ' ').trim();
        if(ribbonShow){
          ribbonShow.textContent = words || ribbonIn.placeholder;
          ribbonShow.classList.toggle('custom-prd7k9__ribbon-word--hint', !words);
        }
        if(ribbonCount) ribbonCount.textContent = ribbonIn.value.length + ' / ' + ribbonMax;
      }
      if(ribbonOn && ribbonFields) ribbonOn.addEventListener('change', function(){
        ribbonFields.hidden = !ribbonOn.checked;
        if(ribbonIn) ribbonIn.removeAttribute('aria-invalid');
        if(ribbonOn.checked && ribbonIn) ribbonIn.focus();
      });
      if(ribbonIn) ribbonIn.addEventListener('input', function(){
        ribbonIn.removeAttribute('aria-invalid');
        drawRibbon();
      });
      drawRibbon();

      /* ---- back in stock (Klaviyo wires in here later) ---- */
      var notifyEl = root.querySelector('[data-notify]');
      var notifyBtn = root.querySelector('[data-notify-btn]');
      if(notifyBtn) notifyBtn.addEventListener('click', function(){
        var em = root.querySelector('[data-notify-email]');
        if(!em || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value)){ if(em) em.focus(); return; }
        var row = root.querySelector('[data-notify-row]');
        if(row) row.innerHTML = '<p class="custom-prd7k9__notify-t">You\'re on the list ✓ We\'ll email you the moment it\'s back.</p>';
      });

      /* ---- add to cart (drawer opens via candy:cart:added) ---- */
      function hostedGiftUrl(value, extension){
        if(typeof value !== 'string') return '';
        try{
          var url = new URL(value, window.location.origin);
          if(url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || url.username || url.password || url.port || url.search || url.hash) return '';
          if(!new RegExp('^/s/files/1/0931/6217/6896/uploads/[A-Za-z0-9_-]+\\.(' + (extension || 'mp4|mov') + ')$', 'i').test(url.pathname)) return '';
          return url.href;
        }catch(error){ return ''; }
      }
      async function cartRequest(path, options, timeout){
        var controller = new AbortController();
        var timer = setTimeout(function(){ controller.abort(); }, timeout || 20000);
        options = options || {};
        options.signal = controller.signal;
        options.credentials = 'same-origin';
        options.cache = 'no-store';
        options.headers = Object.assign({ 'Accept': 'application/json' }, options.headers || {});
        try{
          var response = await fetch(cartRoot + path, options);
          var body;
          try{ body = await response.json(); }catch(parseError){
            var invalid = new Error(response.status === 413 ? 'This video is too large to upload. Choose a smaller video.' : 'The basket response could not be read.');
            invalid.rejected = response.status >= 400 && response.status < 500;
            throw invalid;
          }
          if(!response.ok){
            var error = new Error(response.status === 413 ? 'This video is too large to upload. Choose a smaller video.' : body && typeof body.description === 'string' ? body.description : 'The item could not be added to your basket.');
            error.rejected = response.status >= 400 && response.status < 500;
            throw error;
          }
          return body;
        }finally{ clearTimeout(timer); }
      }
      async function readCart(){
        var cart = await cartRequest('cart.js');
        if(!cart || !Array.isArray(cart.items)) throw new Error('We could not verify your basket.');
        return cart;
      }
      function attemptLines(cart, attempt){
        return cart.items.filter(function(line){
          return line.properties && line.properties['_Gift upload ID'] === attempt.id;
        });
      }
      function verifiedGiftLine(lines, attempt, responseUrl){
        if(lines.length !== 1) return null;
        var line = lines[0];
        var url = hostedGiftUrl(line.properties && line.properties['Gift video']);
        var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
        if(String(line.variant_id || line.id) !== String(attempt.variant) || line.quantity !== attempt.quantity) return null;
        if(String(plan && plan.id || '') !== String(attempt.plan || '')) return null;
        if(!url || (responseUrl && url !== responseUrl)) return null;
        return line;
      }
      async function attachGiftPdf(line, attempt, maker){
        var original = Object.assign({}, line.properties);
        var title = line.product_title || line.title || '';
        if(line.variant_title && line.variant_title !== 'Default Title') title += ' (' + line.variant_title + ')';
        var pdf = maker.create({ video: original['Gift video'], message: original['Gift message'] || '', title: title });
        var data = new FormData();
        data.set('id', line.key);
        data.set('quantity', String(attempt.quantity));
        // cart/change replaces all properties: keep the video, gift message and ribbon association.
        Object.keys(original).forEach(function(key){ data.set('properties[' + key + ']', original[key]); });
        data.set('properties[_Gift video card PDF]', pdf, pdf.name);
        try{ await cartRequest('cart/change.js', { method: 'POST', body: data }, 120000); }
        catch(error){ /* A lost response may still have saved the PDF. Read back before deciding. */ }
        var finalLine = verifiedGiftLine(attemptLines(await readCart(), attempt), attempt, original['Gift video']);
        if(!finalLine || !hostedGiftUrl(finalLine.properties['_Gift video card PDF'], 'pdf') ||
          !Object.keys(original).every(function(key){
            return String(finalLine.properties[key]).replace(/\r\n/g, '\n') === String(original[key]).replace(/\r\n/g, '\n');
          })) throw new Error('The gift card PDF could not be saved.');
        return finalLine;
      }
      async function removeOwnedAttempt(lines, attempt){
        /* The unique property isolates this new line; never clear the shopper's cart. */
        for(var index = 0; index < lines.length; index++){
          if(!lines[index].key) throw new Error('The new basket item could not be identified.');
          await cartRequest('cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lines[index].key, quantity: 0 })
          });
        }
        var after = await readCart();
        if(attemptLines(after, attempt).length) throw new Error('The new basket item could not be removed.');
      }
      function newId(){
        return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      }
      /* adds a ribbon line; after a failure it looks for the line first, so a lost reply never charges two ribbons */
      async function addRibbon(item){
        for(var tries = 0; tries < 2; tries++){
          try{
            await cartRequest('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
            return true;
          }catch(error){
            try{
              var cart = await readCart();
              if(cart.items.some(function(line){ return line.properties && line.properties['Ribbon text'] && line.properties['_Ribbon ID'] === item.properties['_Ribbon ID']; })) return true;
            }catch(readError){}
          }
        }
        return false;
      }
      function resetRibbon(){
        if(ribbonOn) ribbonOn.checked = false;
        if(ribbonFields) ribbonFields.hidden = true;
        if(ribbonIn) ribbonIn.value = '';
        drawRibbon();
      }
      function lockForReview(message){
        addLocked = true;
        cartMessage(message + ' Check your basket before reloading this page to try again.', true);
        if(giftBox && giftBox.checked) giftMessage('We could not confirm this gift. Please check your basket before continuing.', true);
      }
      async function addToCart(){
        if(!cur || !cur.available || addPending || addLocked) return;
        var withGift = !!(giftBox && giftBox.checked);
        var ribbon = withGift ? ribbonWords() : '';
        if(withGift && ribbonOn && ribbonOn.checked && !ribbon){
          giftMessage('Write the words for the ribbon, or untick the ribbon.', true);
          cartMessage('Enter the ribbon words in the gift box below.');
          if(ribbonIn){ ribbonIn.setAttribute('aria-invalid', 'true'); ribbonIn.focus(); }
          return;
        }
        /* with a ribbon, an Upload tab left empty means a gift with no video */
        var upload = withGift && giftMode === 'upload' && !(ribbon && !giftFile && !giftChecking);
        if(upload && (giftChecking || !giftFile)){
          giftMessage(giftChecking ? (giftShrinking ? 'Wait for your video to finish getting smaller.' : 'Wait for the video check to finish.') : 'Choose a playable video before adding this gift to your basket.', true);
          cartMessage('Your gift needs a video. Choose one in the gift box below.');
          if(fileIn) fileIn.focus();
          return;
        }
        var writtenMode = withGift && giftMode === 'write';
        var msg = writtenMode ? root.querySelector('[data-gift-msg]') : null;
        var writtenMessage = msg ? msg.value.trim().slice(0, 250) : '';
        if(writtenMode && !writtenMessage && !ribbon){
          giftMessage('Write a message before adding this gift to your basket.', true);
          cartMessage('Enter your gift message in the gift box below.');
          if(msg){ msg.setAttribute('aria-invalid', 'true'); msg.focus(); }
          return;
        }
        if(msg) msg.removeAttribute('aria-invalid');
        /* Capture the purchase now: changing the size during the request cannot change it. */
        var subA = subLive();
        var selectedFile = upload ? giftFile : null;
        var selectedQuantity = qty;
        var selectedVariant = cur.id;
        var selectedPlan = subA ? subA.id : null;
        var props = {};
        /* "Gift: Yes" asks Order Printer for a card, so a ribbon-only gift goes without it (its ribbon line already
           says what to print and for which item) */
        if(withGift && (upload || writtenMessage)){
          props['Gift'] = 'Yes';
          if(writtenMessage) props['Gift message'] = writtenMessage;
        }
        var ribbonItem = null;
        if(ribbon && ribbonBox){
          props['_Ribbon ID'] = newId();
          var titleEl = root.querySelector('.custom-prd7k9__title');
          var forName = (titleEl ? titleEl.textContent.trim() : '') + (cur.title && cur.title !== 'Default Title' ? ' (' + cur.title + ')' : '');
          ribbonItem = { id: Number(ribbonBox.getAttribute('data-ribbon-variant')), quantity: 1, properties: { 'Ribbon text': ribbon, 'For': forName, '_Ribbon ID': props['_Ribbon ID'] } };
        }
        var attempt = upload ? { id: newId(), variant: selectedVariant, quantity: selectedQuantity, plan: selectedPlan } : null;
        var request;
        if(upload){
          var form = new FormData();
          form.append('id', String(selectedVariant));
          form.append('quantity', String(selectedQuantity));
          if(selectedPlan) form.append('selling_plan', String(selectedPlan));
          form.append('properties[Gift]', props.Gift);
          form.append('properties[_Gift upload ID]', attempt.id);
          if(ribbonItem) form.append('properties[_Ribbon ID]', props['_Ribbon ID']);
          form.append('properties[Gift video]', selectedFile, selectedFile.name);
          /* Let the browser set the multipart boundary. JSON would lose the file bytes. */
          request = { method: 'POST', body: form };
        }else{
          var item = { id: selectedVariant, quantity: selectedQuantity, properties: props };
          if(selectedPlan) item.selling_plan = selectedPlan;
          /* with no upload the gift and its ribbon go in together, in one request */
          request = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ribbonItem ? [item, ribbonItem] : [item] }) };
        }
        addPending = true;
        cartMessage(upload ? 'Uploading your video and adding the gift. Please keep this page open.' : 'Adding to your basket...');
        if(upload) giftMessage('Uploading your video. Please keep this page open.');
        else if(writtenMode) giftMessage('Adding your gift message to the basket...');
        syncAddControls();
        var added = null, addError = null;
        try{
          var pdfMaker;
          if(upload){
            // Resolve dependencies before adding anything; an artwork/network failure leaves the cart intact.
            try{
              if(!window.c4uGiftVideoPdf) throw new Error('The gift card could not be prepared. Reload the page and try again.');
              pdfMaker = await window.c4uGiftVideoPdf.prepare({
                qrSrc: giftFields.getAttribute('data-gift-qr'), logoSrc: giftFields.getAttribute('data-gift-logo'),
                backgroundSrc: giftFields.getAttribute('data-gift-card-art')
              });
            }catch(error){ giftMessage(error.message, true); cartMessage('Gift not added. Please try again.'); return; }
          }
          try{ added = await cartRequest('cart/add.js', request, upload ? 120000 : 30000); }
          catch(error){ addError = error; }
          if(upload){
            /* Even a lost add response may have committed. Reconcile this ID before any retry. */
            var cart;
            try{ cart = await readCart(); }
            catch(error){ lockForReview('The upload result could not be verified.'); return; }
            var lines = attemptLines(cart, attempt);
            var responseItem = added && (added.items ? added.items[0] : added);
            var responseUrl = hostedGiftUrl(responseItem && responseItem.properties && responseItem.properties['Gift video']);
            var confirmed = verifiedGiftLine(lines, attempt, responseUrl);
            if(confirmed){
              giftMessage('Preparing your gift card. Please keep this page open.');
              try{ confirmed = await attachGiftPdf(confirmed, attempt, pdfMaker); }
              catch(pdfError){
                try{
                  // The unique upload ID isolates this attempt, including its changed line key.
                  await removeOwnedAttempt(attemptLines(await readCart(), attempt), attempt);
                  giftMessage('Your gift card could not be saved. The new gift item was removed; your other basket items were kept. Please try again.', true);
                  cartMessage('Gift not added: its card could not be saved. Please try again.');
                }catch(cleanupError){ lockForReview('The gift card could not be safely verified or removed.'); }
                return;
              }
              resetGiftFile();
              /* the video is in; its ribbon follows as a small second add */
              var ribbonAdded = !ribbonItem || await addRibbon(ribbonItem);
              if(!ribbonAdded){
                giftMessage('Video uploaded and attached to this item in your basket, but the ribbon could not be added. Remove this gift from your basket and add it again to get the ribbon.', true);
                cartMessage('Gift added with its video, without the ribbon.');
              }else{
                giftMessage('Video uploaded and attached to this item in your basket.' + (ribbonItem ? ' Its ribbon is in your basket too.' : ''));
                cartMessage(ribbonItem ? 'Gift added with its video and ribbon.' : 'Gift added with its video.');
                if(ribbonItem) resetRibbon();
              }
            }else if(lines.length){
              try{
                await removeOwnedAttempt(lines, attempt);
                giftMessage('The video could not be confirmed. The new gift item was removed; your other basket items were kept. Try the upload again.', true);
                cartMessage('Gift not added: its video could not be verified. You can try again.');
              }catch(error){ lockForReview('The new gift item could not be safely verified or removed.'); }
              return;
            }else if(addError && addError.rejected){
              giftMessage(addError.message + ' Your video has not been attached to a basket item.', true);
              cartMessage(addError.message);
              return;
            }else{
              /* No line yet is not proof a timed-out upload will never commit. */
              lockForReview('The upload may still be processing, so another upload has been paused.');
              return;
            }
          }else{
            if(addError){
              if(addError.rejected) cartMessage(addError.message);
              else lockForReview('We could not confirm whether this item was added.');
              return;
            }
            cartMessage(ribbonItem ? 'Added to your basket with its ribbon.' : 'Added to your basket.');
            if(ribbonItem){
              giftMessage(props['Gift message'] ? 'Gift message and ribbon added to this item in your basket.' : 'Ribbon added to this item in your basket.');
              resetRibbon();
            }else if(writtenMode) giftMessage('Gift message added to this item in your basket.');
          }
            document.dispatchEvent(new CustomEvent('candy:cart:added'));
        }catch(error){
          lockForReview('An unexpected error prevented us from confirming your basket.');
        }finally{
          addPending = false;
          syncAddControls();
        }
      }
      if(atcBtn) atcBtn.addEventListener('click', addToCart);
      var barAtc = root.querySelector('[data-bar-atc]');
      if(barAtc) barAtc.addEventListener('click', addToCart);

      /* ---- sticky mobile bar: shows once the main ATC scrolls off ---- */
      if(barEl && atcBtn && window.matchMedia('(max-width: 768px)').matches){
        var ticking = false;
        function evalBar(){
          ticking = false;
          var r = atcBtn.getBoundingClientRect();
          var show = !!(cur && cur.available && r.bottom < 0);
          barEl.classList.toggle('custom-prd7k9__bar--show', show);
          barEl.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
        CP.onWindow(root, 'scroll', function(){
          if(!ticking){ ticking = true; window.requestAnimationFrame(evalBar); }
        }, { passive: true });
        evalBar();
      }


      /* ---- short description read more (client 2026-08-31: "Readmore button lagawo") ----
         The blurb under the price is a 24-word trim of the long copy; the full text ships
         beside it in a hidden span and this swaps the two in place. The button is rendered
         hidden by the section and revealed here, so if this file never runs the paragraph is
         a clean trim rather than a control that does nothing. */
      (function shortMore(){
        var box = root.querySelector('[data-prd-short]');
        if(!box) return;
        var btn = root.querySelector('[data-prd-more]');
        var trim = box.querySelector('[data-short-t]');
        var full = box.querySelector('[data-short-f]');
        if(!btn || !trim || !full) return;
        btn.hidden = false;
        function setMore(v){
          trim.hidden = v;
          full.hidden = !v;
          btn.setAttribute('aria-expanded', v ? 'true' : 'false');
          btn.textContent = v ? 'Read less' : 'Read more';
        }
        btn.addEventListener('click', function(){
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          var to = window.c4uMorphNext ? window.c4uMorphNext(box, isOpen) : !isOpen;
          /* the height glides like the collection Filters row (window.c4uMorph, snippets/candy-head.liquid) */
          if(window.c4uMorph) window.c4uMorph(box, setMore, to); else setMore(to);
        });
      })();

      paint();
  });
})();
